import React from "react";
import { Modal } from "react-bootstrap";

// const stages = [
//   { label: "Hot", type: "HOT", color: "#FF6B6B" },
//   { label: "Cold", type: "COLD", color: "#4A90E2" },
//   { label: "Warm", type: "WARM", color: "#FFD93D" },
//   { label: "Delivered", type: "DELIVERY", color: "#6BCB77" },
//   { label: "Invalid", type: "INVALID", color: "#9E9E9E" },
//   { label: "Lost", type: "LOST", color: "#F56C6C" },
// ];

const MovetoStageMenu = ({
  showModal,
  onClose,
  stages,
  modalData,
  handleStageMove,
}) => {
  return (
    <Modal
      show={showModal}
      onHide={onClose}
      centered
      keyboard={false}
    >
      <Modal.Body>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ul
            style={{
              display: "flex",
              gap: "18px",
              padding: "0",
              margin: "0",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {stages.map(({ label, type, color, value }) => (
              <li
                key={type}
                style={{
                  listStyleType: "none",
                  cursor: "pointer",
                  padding: "8px 10px",
                  backgroundColor: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  color: color,
                  textAlign: "center",
                  fontWeight: "bold",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(0, 0, 0, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(0, 0, 0, 0.1)";
                }}
                onClick={() => {
                  handleStageMove({type, value}, modalData);
                }}
              >
                {label}
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MovetoStageMenu;
